// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { USInfoModel } from '../Classes/USInfoModel';
import { AccountModel } from '../Classes/AccountModel';
export class OpportunityModelRequest {
  opportunityId: string;
  opportunityName: string;
  siteID: string;
  revenue: string;
  closeDate: string;
  plSegment: string;
  ltMechanicalIssuesMitigation: string;
  plSalesOffice: string;
  plSubSegment: string;
  dProjectStartDate: string;
  dProjectEndDate: string;
  cEstimateSalePrice: string;
  pcGrossMarginPercent: string;
  pcEstimateGM: string;
  plIsCustomerOrEndUserFederalEntity: string;
  stSAPJobNumber: string;
  bsesNationalAccts: string;
  plGSASchedule: string;
  stQuotationNumber: string;
  governmentAgency: string;
  governmentEntity: string;
  accountId: string;
  opportunityLegacyId: string;
  soldToSAPNumber: string;
  shipToSAPNumber: string;
  endUserSAPNumber: string;
  endUserAccountId: string;
  shipToAccountId: string;
  isRestrictedOpportunity: string;
  buyAmerican: string;
  opportunityDescription: string;
  opportunityGuid: string;
  billToSAPNumber: string;
  billToAccountId: string;
  salesType: string;
  reasonForException: string;
  isCostReviewRequired: boolean;
  costReviewStatus: string;
  isCUI: boolean;
  usSpecificInformation: USInfoModel;
  isChangeOrder: boolean;
  accounts: AccountModel[];
}
